import React from 'react';
import { Link } from 'react-router-dom';
import { calculaPrevision, formatMs, getControlById } from '../utils/time';

class ResultadoListTodos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            time: 0
        };
    }

    componentDidMount() {
        this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    render() {
        const { resultados, sectores, controles, competicion } = this.props;

        const resultadosOrdenados = resultados
            .map((resultado) => {
                const prevision = calculaPrevision(competicion, controles, sectores, resultado);
                const controlUltimo = getControlById(controles, resultado.control_ultimo_id);

                // META (para ordenar finalizados y diferencias)
                const metaControl = controles.find(c => c.tipo === 'META');
                let tiempoMetaNeto = null;
                if (metaControl) {
                    const tiempoMeta = resultado['control_' + metaControl.id + '_tiempo'];
                    if (tiempoMeta) {
                        let tiempoInicioCorrector = 0;
                        if (competicion.tipo === 'TIEMPONETO' && resultado.start) {
                            tiempoInicioCorrector = resultado.start - (competicion.guntime || 0);
                        }
                        tiempoMetaNeto = tiempoMeta - tiempoInicioCorrector;
                    }
                }

                // Tiempo en carrera en "tiempo real"
                let tiempoEnCarrera = null;
                if (controlUltimo) {
                    const guntime = competicion.guntime || 0;
                    const [Y, M, D] = competicion.fecha_inicio.split('-').map(Number);
                    const fechaBase = new Date(Y, M - 1, D, 0, 0, 0, 0);
                    const ahora = this.state.time || Date.now();

                    // Base: guntime de competición
                    let tiempoAhora = ahora - (fechaBase.getTime() + guntime);

                    // Si el atleta tiene guntime propio
                    if (resultado.guntime) {
                        tiempoAhora = ahora - (fechaBase.getTime() + resultado.guntime);
                    }

                    // En TIEMPONETO usar start si existe
                    if (competicion.tipo === 'TIEMPONETO') {
                        tiempoAhora = resultado.start
                            ? ahora - (fechaBase.getTime() + resultado.start)
                            : ahora - (fechaBase.getTime() + guntime);
                    }

                    tiempoEnCarrera = tiempoAhora;
                }

                return { ...resultado, prevision, controlUltimo, tiempoEnCarrera, tiempoMetaNeto };
            })
            .sort((a, b) => {
                const getPrioridad = (r, meta) => {
                    if (r.descalificado) return 5;
                    if (r.retirado) return 4;
                    if (meta) return 1;
                    if (r.controlUltimo) return 2;
                    if (r.start) return 3;
                    return 6;
                };

                const pa = getPrioridad(a, a.tiempoMetaNeto);
                const pb = getPrioridad(b, b.tiempoMetaNeto);

                if (pa !== pb) return pa - pb;

                if (pa === 1) {
                    return a.tiempoMetaNeto - b.tiempoMetaNeto;
                }

                if (pa === 2) {
                    if (a.prevision.tiempoTotal && b.prevision.tiempoTotal) {
                        return a.prevision.tiempoTotal - b.prevision.tiempoTotal;
                    }
                    if (a.prevision.tiempoTotal) return -1;
                    if (b.prevision.tiempoTotal) return 1;
                }

                if (pa === 3) {
                    return (a.start || 0) - (b.start || 0);
                }
                return a.dorsal - b.dorsal;
            });

        // ¿Ya empezó la comp?
        let yaEmpezó = false;
        if (competicion.fecha_inicio && competicion.guntime) {
            const [Y, M, D] = competicion.fecha_inicio.split('-').map(Number);
            const fechaBase = new Date(Y, M - 1, D, 0, 0, 0, 0);
            const timestampGuntime = fechaBase.getTime() + competicion.guntime;
            yaEmpezó = Date.now() > timestampGuntime;
        }

        // Posiciones reales
        let posicionActual = 0;
        const posicionesPorDorsal = {};
        resultadosOrdenados.forEach((r) => {
            const metaControl = controles.find(c => c.tipo === 'META');
            const tiempoMeta = metaControl ? r['control_' + metaControl.id + '_tiempo'] : null;
            const control = r.controlUltimo;
            if (!r.descalificado && !r.retirado) {
                if (tiempoMeta || (control && r.tiempoEnCarrera)) {
                    posicionActual++;
                    posicionesPorDorsal[r.dorsal] = posicionActual;
                }
            }
        });

        return (
            <div className="w-full">
                <div className="mx-auto max-w-5xl px-0 md:px-36">
                    <ul className="space-y-3">
                        {resultadosOrdenados.map((resultado) => {
                            const metaControl = controles.find(c => c.tipo === 'META');
                            const tiempoMeta = metaControl ? resultado['control_' + metaControl.id + '_tiempo'] : null;
                            const control = resultado.controlUltimo;

                            let estado = yaEmpezó ? 'NO PRESENTADO/SIN DATOS' : 'INSCRITO';
                            let tiempoMostrar = yaEmpezó ? 'NO PRESENTADO/SIN DATOS' : 'INSCRITO';
                            let tiempoMostrarMovil = tiempoMostrar;

                            if (resultado.descalificado) {
                                estado = 'DESCALIFICADO';
                                tiempoMostrar = 'DESCALIFICADO';
                                tiempoMostrarMovil = '';
                            } else if (resultado.retirado) {
                                estado = 'RETIRADO';
                                tiempoMostrar = 'RETIRADO';
                                tiempoMostrarMovil = '';
                            } else if (tiempoMeta) {
                                let tiempoInicioCorrector = 0;
                                if (competicion.tipo === 'TIEMPONETO' && resultado.start) {
                                    tiempoInicioCorrector = resultado.start - (competicion.guntime || 0);
                                }
                                const tiempoMetaNeto = tiempoMeta - tiempoInicioCorrector;

                                estado = 'FINALIZADA';
                                tiempoMostrar = formatMs(tiempoMetaNeto, competicion.mostrar_tiempo_centesimas);
                                tiempoMostrarMovil = tiempoMostrar;
                            } else if (control) {
                                estado = `Último paso: ${control.nombre}`;
                                if (resultado.prevision.tiempoTotal && !competicion.carrera_finalizada && controles.some(c => c.prevision)) {
                                    tiempoMostrar = formatMs(resultado.prevision.tiempoTotal);
                                    tiempoMostrarMovil = tiempoMostrar;
                                } else {
                                    tiempoMostrar = '---';
                                    tiempoMostrarMovil = '---';
                                }
                            } else if (resultado.start) {
                                estado = 'CON SALIDA';
                                tiempoMostrar = '---';
                                tiempoMostrarMovil = '---';
                            } else {
                                tiempoMostrarMovil = '';
                            }

                            // Diferencia con el primer finalizado
                            const diferenciaConLiderFinalizados = (() => {
                                const primerFinalizado = resultadosOrdenados.find(r =>
                                    r.tiempoMetaNeto && !r.descalificado && !r.retirado
                                );

                                if (!primerFinalizado || resultado.dorsal === primerFinalizado.dorsal || !primerFinalizado.tiempoMetaNeto || !resultado.tiempoMetaNeto) {
                                    return '-';
                                }

                                const redondearComoFormatMs = (ms) => {
                                    let s = Math.floor(ms / 1000);
                                    const milisegundos = ms % 1000;
                                    if (milisegundos > 0) s++;
                                    return s;
                                };

                                const segundosLider = redondearComoFormatMs(primerFinalizado.tiempoMetaNeto);
                                const segundosActual = redondearComoFormatMs(resultado.tiempoMetaNeto);
                                const difSegundos = segundosActual - segundosLider;

                                if (difSegundos === 0) return '-';

                                const h = Math.floor(difSegundos / 3600);
                                const m = Math.floor((difSegundos % 3600) / 60);
                                const s = difSegundos % 60;
                                const z = (v, n) => String(v).padStart(n, '0');

                                return `+ ${z(h, 2)}:${z(m, 2)}:${z(s, 2)}`;
                            })();

                            const puestoBadge = (resultado.descalificado || resultado.retirado)
                                ? '-'
                                : ((tiempoMeta || (control && resultado.tiempoEnCarrera))
                                    ? posicionesPorDorsal[resultado.dorsal]
                                    : '-');

                            return (
                                <li key={resultado.dorsal} className="list-none">
                                    <Link
                                        to={`/competicion/${competicion.id}/dorsal/${resultado.dorsal}`}
                                        className="block py-3 px-4 md:px-0 hover:bg-slate-900/70 transition"
                                    >
                                        <div className="flex items-center gap-3">
                                            {/* Puesto */}
                                            <div
                                                className="grid place-items-center h-10 w-10 rounded-lg text-sm font-semibold bg-slate-800 text-slate-200 border border-slate-700"
                                            >
                                                {puestoBadge}
                                            </div>

                                            {/* Nombre + info */}
                                            <div className="min-w-0 flex-1">
                                                <div className="truncate text-white font-medium font-montserrat">
                                                    {resultado.nombre} {resultado.apellidos}
                                                </div>

                                                <div className="mt-1 text-sm text-slate-400 font-montserrat">
                                                    Dorsal <strong className="text-slate-200">{resultado.dorsal}</strong>
                                                    {resultado.categoriaNombre ? `, ${resultado.categoriaNombre}` : ''}
                                                    {resultado.clubNombre ? `, ${resultado.clubNombre}` : ''}
                                                    &nbsp;- <span className="text-white font-medium">{estado}</span>
                                                </div>
                                            </div>

                                            {/* Tiempo / estado */}
                                            <div className="text-right">
                                                {tiempoMostrarMovil !== '---' && tiempoMostrarMovil !== '' && !competicion.carrera_finalizada && !tiempoMeta ? (
                                                    <div>
                                                        <div className="text-[10px] uppercase tracking-wide text-slate-400 mb-1 font-mono">PREVISIÓN</div>
                                                        <div className="text-red-400 font-mono text-sm">
                                                            {tiempoMostrarMovil}
                                                        </div>
                                                        {controles.some(c => c.prevision) && resultado.prevision.tiempoTotal && (
                                                            <div className="text-red-400 font-mono text-xs mt-1">
                                                                {formatMs(((competicion.tipo === "TIEMPONETO" && resultado.start) ? resultado.start : (resultado.guntime || competicion.guntime)) + resultado.prevision.tiempoTotal)} h
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div className="text-white font-mono text-sm">
                                                        {tiempoMostrarMovil}
                                                        {resultado.tiempoMetaNeto && !resultado.descalificado && !resultado.retirado && (
                                                            <div className="mt-1 text-xs text-slate-400">
                                                                {diferenciaConLiderFinalizados}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Progreso */}
                                        {!competicion.carrera_finalizada &&
                                            resultado.prevision.porcentaje !== null && controles.some(c => c.prevision) &&
                                            !resultado.descalificado &&
                                            !resultado.retirado &&
                                            !tiempoMeta && (
                                                <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-slate-800">
                                                    <div
                                                        className="h-full bg-red-500"
                                                        style={{ width: `${resultado.prevision.porcentaje}%` }}
                                                    />
                                                </div>
                                            )}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        );
    }
}

export default ResultadoListTodos;